import { Component, OnInit, ViewChild } from "@angular/core";
import { AuthService } from "src/app/services/auth/auth.service";
import { RouterService } from "src/app/services/router/router.service";

import { RemoteConfigService } from "src/app/services/remote-config/remote-config.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import firebase from "firebase/app";

import { PointsService } from "../../../services/points/points.service";
import { UtilsService } from "../../../services/utils/utils.service";
import { TagsService } from "src/app/services/tags/tags.service";
import { StorageService } from "src/app/services/storage/storage.service";
import { RedemptionService } from "src/app/services/redemption/redemption.service";

@Component({
  selector: "app-tabs",
  templateUrl: "tabs.page.html",
  styleUrls: ["tabs.page.scss"],
})
export class TabsPage implements OnInit {
  @ViewChild("myTabs") myTabs: any;
  points: any;
  redemptionLimit = false;
  isRedemptionActive

  constructor(
    public authService: AuthService,
    public routerService: RouterService,
    public languageService: LanguagesService,
    private utilsService: UtilsService,
    private remoteConfig: RemoteConfigService,
    private tagsService: TagsService,
    private redemptionService: RedemptionService,
    private storageService: StorageService,
  ) {
    this.authService.getUSerInfoFromFirebase().then((res: firebase.User) => {
    });
  }

  ngOnInit() {
    this.checkRedemption();
    this.utilsService.getUserPoints().then((result: any) => {
      this.points = result;
    });
  }

  async checkRedemption(){
    const programInfo = await this.redemptionService.getProgramInfo();
    this.redemptionLimit = programInfo['redemption_limit']?.enabled ? true : false;
    this.isRedemptionActive = await this.redemptionService.validateRedemption();
  }

  async getChange(){
    const auth = await this.storageService.get('changeAuth');
    if(auth == 'phone'){
      return;
    }
    this.authService.logout();
    this.routerService.redirect("login");
  }
  getTextsIUTabs() {
    return this.languageService.textsIU.tabs;
  }
  async getTab(myTab) {
    // console.log(myTab);
    if (document.querySelector(".tab-selected")) {
      return false;
    }
    return true;
  }
  tabSelected(idTab) {
    switch (idTab) {
      case 1:
        this.tagsService.setEventTag(
          "tabs_menu",
          "tabs_home_clicked",
          false,
          true
        );
        break;
      case 2:
        this.tagsService.setEventTag(
          "tabs_menu",
          "tabs_content_clicked",
          false,
          true
        );
        break;
      case 3:
        this.tagsService.setEventTag(
          "tabs_menu",
          "tabs_indicators_clicked",
          false,
          true
        );
        break;
      case 4:
        this.tagsService.setEventTag(
          "tabs_menu",
          "tabs_rewards_clicked",
          false,
          true
        );
        break;
      case 5:
        this.tagsService.setEventTag(
          "tabs_menu",
          "tabs_wall_clicked",
          false,
          true
        );
        break;

      default:
        console.log("no se encontro event tag");
        break;
    }
  }
}
